module.exports = __webpack_public_path__ + "img/Battle.f8b12851.jpg";